// extracted by mini-css-extract-plugin
module.exports = {"grid":"section_grid__4WVBP"};